import React from 'react';
import { Title } from './AccordionTitle.styles';
import { AccordionTitleProps } from '@sleepunique/types/accordion-title-type';

type Props = {};

const AccordionTitle = ({ label, text }: AccordionTitleProps) => (
  <Title>
    <span>{label}</span>
    <span className="text">{text}</span>
  </Title>
);

export default AccordionTitle;
